module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hcC0g"))).then(() => parcelRequire('d0iPb'));